import React from 'react'
import { Redirect } from 'react-router-dom'
import { withNotifier } from 'stylist'

const RouteServersNew = ({ notify }) => {
  notify(
    'info',
    'In order to add a Server, choose a product, click Servers -> New',
    { timeout: 5000 }
  )
  return <Redirect to={'/admin/products'} />
}

export default withNotifier(RouteServersNew)



// WEBPACK FOOTER //
// ./src/routes/admin/servers/new.js